/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShareClaimPendingInviteResponseData
 */
export interface ShareClaimPendingInviteResponseData {
    /**
     * The ID of the pending claim_invite record (used for revoke).
     * @type {number}
     * @memberof ShareClaimPendingInviteResponseData
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ShareClaimPendingInviteResponseData
     */
    claimId: number;
    /**
     * The invited email address.
     * @type {string}
     * @memberof ShareClaimPendingInviteResponseData
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ShareClaimPendingInviteResponseData
     */
    accessLevel: ShareClaimPendingInviteResponseDataAccessLevelEnum;
    /**
     * 
     * @type {Date}
     * @memberof ShareClaimPendingInviteResponseData
     */
    expiresAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ShareClaimPendingInviteResponseData
     */
    createdAt: Date;
}


/**
 * @export
 */
export const ShareClaimPendingInviteResponseDataAccessLevelEnum = {
    Ro: 'ro',
    Rw: 'rw'
} as const;
export type ShareClaimPendingInviteResponseDataAccessLevelEnum = typeof ShareClaimPendingInviteResponseDataAccessLevelEnum[keyof typeof ShareClaimPendingInviteResponseDataAccessLevelEnum];


/**
 * Check if a given object implements the ShareClaimPendingInviteResponseData interface.
 */
export function instanceOfShareClaimPendingInviteResponseData(value: object): value is ShareClaimPendingInviteResponseData {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('accessLevel' in value) || value['accessLevel'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ShareClaimPendingInviteResponseDataFromJSON(json: any): ShareClaimPendingInviteResponseData {
    return ShareClaimPendingInviteResponseDataFromJSONTyped(json, false);
}

export function ShareClaimPendingInviteResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShareClaimPendingInviteResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimId': json['claimId'],
        'email': json['email'],
        'accessLevel': json['accessLevel'],
        'expiresAt': (new Date(json['expiresAt'])),
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function ShareClaimPendingInviteResponseDataToJSON(json: any): ShareClaimPendingInviteResponseData {
    return ShareClaimPendingInviteResponseDataToJSONTyped(json, false);
}

export function ShareClaimPendingInviteResponseDataToJSONTyped(value?: ShareClaimPendingInviteResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'claimId': value['claimId'],
        'email': value['email'],
        'accessLevel': value['accessLevel'],
        'expiresAt': ((value['expiresAt']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

